angular.module('bizmetryApp').component('swaggerViewer', {
    bindings: {
        spec: '<'
    },
    template: '<div class="sv-wrapper"><div class="sv-ui-mount"></div></div>',
    controller: function ($timeout, $element, $scope) {
        var ctrl = this;
        var uiInstance = null;
        var mountEl    = null;

        ctrl.$onInit = function () {
            mountEl = $element[0].querySelector('.sv-ui-mount');

            // ✅ Si spec ya llegó antes de que el DOM estuviera listo, inicializar ahora
            if (ctrl.spec) {
                _init(ctrl.spec);
            }
        };

        ctrl.$onChanges = function (changes) {
            if (changes.spec && changes.spec.currentValue) {
                // mountEl puede ser null si $onChanges se dispara antes de $onInit
                // En ese caso $onInit lo manejará
                if (mountEl) {
                    _init(changes.spec.currentValue);
                }
            }
        };

        ctrl.$onDestroy = function () {
            if (mountEl) mountEl.innerHTML = '';
            uiInstance = null;
        };

        function _init(spec) {
            if (!spec || typeof spec !== 'object') return;
            if (!mountEl) return;

            mountEl.innerHTML = '';
            uiInstance = null;

            $timeout(function () {
                if (!window.SwaggerUIBundle) {
                    console.error('❌ [SwaggerViewer] SwaggerUIBundle not loaded — check CDN script tag');
                    return;
                }

                uiInstance = SwaggerUIBundle({
                    spec:             spec,
                    domNode:          mountEl,
                    deepLinking:      false,
                    presets: [
                        SwaggerUIBundle.presets.apis,
                        SwaggerUIBundle.SwaggerUIStandalonePreset
                    ],
                    layout:                   'BaseLayout',
                    defaultModelsExpandDepth: -1,
                    defaultModelExpandDepth:   1,
                    displayRequestDuration:    true,
                    tryItOutEnabled:           false,
                    supportedSubmitMethods:    [],
                    validatorUrl:              null
                });

                console.log('✅ [SwaggerViewer] SwaggerUIBundle initialized');
            }, 50); // ← pequeño delay para asegurar que el DOM está painted
        }
    }
});